<template>
<div>
    <jet-form-section>
        <template #title>
            <span v-if="!mobile_device">Dispositivo móvel autorizado</span>
            <span v-else>Autorização de aplicativo móvel</span>
        </template>

        <template #description>

        </template>

        <template #form>
            <div class="col-span-6"  v-if="mobile_device != null">
                    <div class="mt-5 space-y-6">
                        <div class="grid gap-4">

                            <div class="flex items-center">
                                <div>
                                    <svg v-if="mobile_device.platform == 'Android'" fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 64 64" width="64px" height="64px"><path d="M 19.925781 4.4589844 C 19.796875 4.4749531 19.670281 4.5169375 19.550781 4.5859375 C 19.072781 4.8619375 18.907594 5.4731719 19.183594 5.9511719 L 21.873047 10.609375 C 18.422305 13.348967 15.974304 17.411516 15.246094 22 L 48.820312 22 C 48.186567 17.305005 45.728211 13.207297 42.199219 10.486328 L 44.816406 5.9511719 C 45.092406 5.4731719 44.927219 4.8619375 44.449219 4.5859375 C 43.971219 4.3099375 43.359984 4.4731719 43.083984 4.9511719 L 40.533203 9.3691406 C 38.11257 7.9228488 35.318554 7.0613328 32.324219 7.0039062 C 29.109568 6.9424535 26.093966 7.8451485 23.509766 9.4433594 L 20.916016 4.9511719 C 20.709016 4.5926719 20.3125 4.4110781 19.925781 4.4589844 z M 24.5 14 C 25.328 14 26 14.672 26 15.5 C 26 16.328 25.328 17 24.5 17 C 23.672 17 23 16.328 23 15.5 C 23 14.672 23.672 14 24.5 14 z M 39.5 14 C 40.328 14 41 14.672 41 15.5 C 41 16.328 40.328 17 39.5 17 C 38.672 17 38 16.328 38 15.5 C 38 14.672 38.672 14 39.5 14 z M 15.039062 24.054688 C 15.027063 24.320688 15 24.583562 15 24.851562 L 15 45.90625 C 15 48.16625 16.791 50 19 50 L 22 50 L 22 56.5 C 22 57.881 23.119 59 24.5 59 C 25.881 59 27 57.881 27 56.5 L 27 50 L 37 50 L 37 56.5 C 37 57.881 38.119 59 39.5 59 C 40.881 59 42 57.881 42 56.5 L 42 50 L 45 50 C 47.209 50 49 48.16625 49 45.90625 L 49 24.947266 L 15.039062 24.054688 z M 9.5 25 C 8.119 25 7 26.119 7 27.5 L 7 35.5 C 7 36.881 8.119 38 9.5 38 C 10.881 38 12 36.881 12 35.5 L 12 27.5 C 12 26.119 10.881 25 9.5 25 z M 54.5 25 C 53.119 25 52 26.119 52 27.5 L 52 35.5 C 52 36.881 53.119 38 54.5 38 C 55.881 38 57 36.881 57 35.5 L 57 27.5 C 57 26.119 55.881 25 54.5 25 z"/></svg>
                                    <svg v-else fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="50px" height="50px"><path d="M 44.527344 34.75 C 43.449219 37.144531 42.929688 38.214844 41.542969 40.328125 C 39.601563 43.28125 36.863281 46.96875 33.480469 46.992188 C 30.46875 47.019531 29.691406 45.027344 25.601563 45.0625 C 21.515625 45.082031 20.664063 47.03125 17.648438 47 C 14.261719 46.96875 11.671875 43.648438 9.730469 40.699219 C 4.300781 32.429688 3.726563 22.734375 7.082031 17.578125 C 9.457031 13.921875 13.210938 11.773438 16.738281 11.773438 C 20.332031 11.773438 22.589844 13.746094 25.558594 13.746094 C 28.441406 13.746094 30.195313 11.769531 34.351563 11.769531 C 37.492188 11.769531 40.8125 13.480469 43.1875 16.433594 C 35.421875 20.691406 36.683594 31.78125 44.527344 34.75 Z M 31.195313 8.46875 C 32.707031 6.527344 33.855469 3.789063 33.4375 1 C 30.972656 1.167969 28.089844 2.742188 26.40625 4.78125 C 24.878906 6.640625 23.613281 9.398438 24.105469 12.066406 C 26.796875 12.152344 29.582031 10.546875 31.195313 8.46875 Z"/></svg>
                                </div>

                                <div class="ml-3">
                                    <div class="text-sm text-gray-600">
                                        <p><b>Modelo: {{ mobile_device.model }}</b></p>
                                        <p>Versão: {{ mobile_device.version }}</p>
                                    </div>

                                    <div>
                                        <div class="text-xs text-gray-500">
                                            <span>Primeiro Acesso {{ mobile_device.created | smallDateTime }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="col-span-6" v-else>
                <h5>Nenhum dispositivo registrado.</h5>
            </div>
        </template>

        <template #actions>
            <div class="mt-5 flex">
                <div v-if="false">
                    <jet-button type="button" @click.native="showCodeModal = true;">
                        Remover dispositivo
                    </jet-button>
                </div>
            </div>
        </template>
    </jet-form-section>
    <jet-confirmation-modal :show="showCodeModal" @close="showCodeModal=false">
        <template #title>
           Autorização
        </template>

        <template #content>
            <jet-form-section class="items-center">
                <template #title>
                    Código de autorização
                </template>

                <template #description>
                    Informe o código de autorização para autenticar sua solicitação
                </template>

                <template #form class=" gap-0">
                    <div class="col-span-6 sm:col-span-6 my-10">
                        <jet-label for="google_code" value="Código de Autorização" />
                        <jet-input id="google_code" type="number" class="mt-1 block w-full" v-model="form.google_code" />
                        <jet-input-error :message="form.error('google_code')" class="mt-2" />
                    </div>
                </template>
            </jet-form-section>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="showCodeModal = false">
                Agora não
            </jet-secondary-button>

            <jet-ok-button class="ml-2" @click.native="changeAuthorization()" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Confirmar
            </jet-ok-button>
        </template>
    </jet-confirmation-modal>
</div>
</template>

<script>
import JetActionMessage from './../../Jetstream/ActionMessage'
import JetButton from './../../Jetstream/Button'
import JetFormSection from './../../Jetstream/FormSection'
import JetInput from './../../Jetstream/Input'
import JetInputError from './../../Jetstream/InputError'
import JetLabel from './../../Jetstream/Label'
import AppLayout from './../../Layouts/AppLayout'
import JetActionSection from './../../Jetstream/ActionSection'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetDangerButton from './../../Jetstream/DangerButton'
import JetConfirmationModal from "./../../Jetstream/ConfirmationModal"
import JetTextarea from "../../Jetstream/Textarea"
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea"
import JetAutoComplete from "../../Jetstream/AutoComplete"
import JetSecondaryButton from "../../Jetstream/SecondaryButton"
import JetMaskedInput from "../../Jetstream/MaskedInput"
import JetFetchDoc from "../../Jetstream/FetchDoc"
import Flash from "../../Helpers/Flash"
import moment from 'moment/dist/moment'
import JetOkButton from "../../Jetstream/OkButton";
export default {
    props: ['user', 'mobile_device'],
    data() {
        return {
            enabling: false,
            showCodeModal: false,
            form: this.$inertia.form({
                removeAccess: this.mobile_device !== null,
                google_code: '',
            }),
        }
    },

    methods: {
        changeAuthorization() {
            this.form.post('/mobilebank', {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.removeAccess = this.mobile_device !== null;
                    this.form.processing = false
                    this.showCodeModal = false;
                },
                onError: () => {
                    this.form.processing = false
                }
            });
        },
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetActionSection,
        JetDangerButton,
        JetConfirmationModal,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetOkButton
    },
}
</script>
